export const TYPES = {
  SNIPPET: 'SNIPPET',
  PITCH: 'PITCH',
  EMAIL: 'EMAIL',
  LINKEDIN: 'LINKEDIN_MESSAGE',
  QUALIFYING_QUESTION: 'QUALIFYING_QUESTION',
};
